import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        
        <div className="footer-center">
          &copy; 2026 Cerebral Palsy Alliance
        </div>

        <nav className="footer-right" aria-label="Legal and feedback">
          <a
            href="https://cpadvance.org/privacy-policy/"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy
          </a>
          <a
            href="https://cpadvance.org/terms-conditions/"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a>
          <Link to="/FeedbackPage" className="footer-link">
            Feedback
          </Link>
        </nav>

      </div>
    </footer>
  );
}